import React from "react";
import { IconProps } from "./IconProps";

const CaretDownIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.8135 7.96155L10.4502 14.3249C10.3911 14.384 10.3209 14.431 10.2437 14.463C10.1664 14.495 10.0836 14.5115 10 14.5115C9.91638 14.5115 9.83357 14.495 9.75632 14.463C9.67907 14.431 9.60889 14.384 9.54979 14.3249L3.18648 7.96155C3.06708 7.84215 3 7.68021 3 7.51135C3 7.34249 3.06708 7.18055 3.18648 7.06114C3.30588 6.94174 3.46783 6.87466 3.63669 6.87466C3.80554 6.87466 3.96749 6.94174 4.08689 7.06114L10 12.9751L15.9131 7.06114C15.9722 7.00202 16.0424 6.95513 16.1197 6.92313C16.1969 6.89113 16.2797 6.87466 16.3633 6.87466C16.4469 6.87466 16.5297 6.89113 16.607 6.92313C16.6842 6.95513 16.7544 7.00202 16.8135 7.06114C16.8726 7.12027 16.9195 7.19045 16.9515 7.2677C16.9835 7.34495 17 7.42774 17 7.51135C17 7.59496 16.9835 7.67775 16.9515 7.755C16.9195 7.83224 16.8726 7.90243 16.8135 7.96155Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5812 7.83125L10.3312 14.0812C10.2434 14.169 10.1242 14.2183 10 14.2183C9.87578 14.2183 9.75664 14.169 9.66875 14.0812L3.41875 7.83125C3.33595 7.74239 3.29087 7.62486 3.29301 7.50342C3.29515 7.38198 3.34435 7.26612 3.43023 7.18023C3.51612 7.09435 3.63198 7.04515 3.75342 7.04301C3.87486 7.04087 3.99239 7.08595 4.08125 7.16875L10 13.0867L15.9187 7.16875C16.0076 7.08595 16.1251 7.04087 16.2466 7.04301C16.368 7.04515 16.4839 7.09435 16.5698 7.18023C16.6556 7.26612 16.7048 7.38198 16.707 7.50342C16.7091 7.62486 16.664 7.74239 16.5812 7.83125Z"
            fill={color}
          />
        </svg>
      );
    case "24Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.0306 9.53063L12.5306 17.0306C12.461 17.1004 12.3782 17.1557 12.2872 17.1934C12.1961 17.2312 12.0986 17.2506 12 17.2506C11.9014 17.2506 11.8038 17.2312 11.7128 17.1934C11.6217 17.1557 11.539 17.1004 11.4694 17.0306L3.96936 9.53063C3.82863 9.3899 3.74957 9.19903 3.74957 9.00001C3.74957 8.80098 3.82863 8.61011 3.96936 8.46938C4.1101 8.32865 4.30097 8.24959 4.49999 8.24959C4.69901 8.24959 4.88988 8.32865 5.03061 8.46938L12 15.4397L18.9694 8.46938C19.039 8.3997 19.1218 8.34442 19.2128 8.30671C19.3039 8.269 19.4014 8.24959 19.5 8.24959C19.5985 8.24959 19.6961 8.269 19.7872 8.30671C19.8782 8.34442 19.9609 8.3997 20.0306 8.46938C20.1003 8.53906 20.1556 8.62179 20.1933 8.71283C20.231 8.80388 20.2504 8.90146 20.2504 9.00001C20.2504 9.09855 20.231 9.19613 20.1933 9.28718C20.1556 9.37822 20.1003 9.46095 20.0306 9.53063Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.53 12.53L16.53 22.53C16.3894 22.6704 16.1987 22.7493 16 22.7493C15.8012 22.7493 15.6106 22.6704 15.47 22.53L5.47 12.53C5.33752 12.3878 5.2654 12.1997 5.26882 12.0054C5.27225 11.8111 5.35096 11.6258 5.48838 11.4883C5.62579 11.3509 5.81118 11.2722 6.00548 11.2688C6.19978 11.2654 6.38782 11.3375 6.53 11.47L16 20.9387L25.47 11.47C25.6122 11.3375 25.8002 11.2654 25.9945 11.2688C26.1888 11.2722 26.3742 11.3509 26.5116 11.4883C26.649 11.6258 26.7277 11.8111 26.7312 12.0054C26.7346 12.1997 26.6625 12.3878 26.53 12.53Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default CaretDownIcon;
